import Main from './views/Main'
import Extract from './views/Extract'
import GameOver from './views/GameOver'
import FinalScore from './views/FinalScore'
import RedirectAuth from './views/RedirectAuth'
import RedirectExternal from './views/RedirectExternal'
import BetGameNew from './views/BetGameNew'
import Rules from './views/Rules'
import StatemenOfUseReport from './views/report/StatementOfUse'
import StatementOfUseGame from './views/StatementOfUseGame'
import Graphic from './views/report/Graphic'
import Competences from './views/report/Competences'
import Ranking from './views/report/Ranking'
import Feedback from './views/report/Feedback'
import Performance from './views/report/Performance'
import GenerateReport from './views/report/GenerateReport'
import Logout from './views/Logout'

// feedback
import FeedbackContainer from './containers/FeedbackContainer'
import FeedbackExperience from './views/feedback/FeedbackExperience'
import FeedbackPreference from './views/feedback/FeedbackPreference'
import FeedbackProblem from './views/feedback/FeedbackProblem'
import FeedbackExplain from './views/feedback/FeedbackExplain'
import FeedbackGift from './views/feedback/FeedbackGift'
import FeedbackFinish from './views/feedback/FeedbackFinish'

// dashboard
import Dashboard from './views/dashboard/Dashboard'

export const routes = [
    { 
        
        path: '/',
        name: 'Bet Game',
        component: BetGameNew,
        // redirect: '/bet-game',
    },
    {
        path: '/solo-game', 
        name: 'Solo game',
        component : Main
    },
    { 
        path: '/extract', 
        name: 'Extract',
        component: Extract,
        props : true
    },
    { 
        path: '/game-over', 
        name: 'GameOver',
        component: GameOver,
        meta : {
            redirect : false
        } 
    },
    { 
        path: '/final-score', 
        name: 'FinalScore',
        component: FinalScore,
        meta : {
            redirect : false
        }
    },
    {
        path: '/statement-game',
        name: "StatementOfUseGame",
        component: StatementOfUseGame
    },
    {
        path: '/redirect-auth',
        name : 'RedirectAuth',
        component: RedirectAuth
    },
    {
        path: '/redirect-external',
        name: "RedirectExternal",
        component: RedirectExternal,
        meta : {
            redirect : false
        }
    },
    {
        path : '/rules',
        name : "Rules",
        component : Rules
    },

    //Report routes

    {
        path: '/report/statement',
        name: "Statement",
        component: StatemenOfUseReport,
        meta : {
            redirect : false
        }
    },
    {
        path: '/report/generate',
        name: "GenerateReport",
        component: GenerateReport,
        meta : {
            redirect : false
        }
    },
    {
        path: '/report/graphic',
        name: "Graphic",
        component: Graphic,
        meta : {
            redirect : false
        }
    },
    {
        path: '/report/competences',
        name: "Competencias",
        component: Competences,
        meta : {
            redirect : false
        }
    },
    {
        path: '/report/ranking',
        name: "Ranking",
        component: Ranking,
        meta : {
            redirect : false
        }
    },
    {
        path: '/report/feedback',
        name: "Feedback",
        component: Feedback,
        meta : {
            redirect : false
        }
    },
    {
        path: '/report/performance',
        name: "Performance",
        component: Performance,
        meta : {
            redirect : false
        }
    },
    {
        path: '/logout',
        name: "Logout",
        component: Logout
    },
    {
        path : '/feedback',
        name : 'Feedback',
        component : FeedbackContainer,
        meta : {
            redirect : false
        },
        children : [
            {
                path : '/feedback-experience',
                name : 'Feedback Experience',
                component : FeedbackExperience,
                meta : {
                    redirect : false
                }
            },
            {
                path : '/feedback-preference',
                name : 'Feedback Preference',
                component : FeedbackPreference,
                meta : {
                    redirect : false
                }
            },
            {
                path : '/feedback-problem',
                name : 'Feedback Problem',
                component : FeedbackProblem,
                meta : {
                    redirect : false
                }
            },
            {
                path : '/feedback-explain',
                name : 'Feedback Explain',
                component : FeedbackExplain,
                meta : {
                    redirect : false
                }
            },
            {
                path : '/feedback-gift',
                name : 'Feedback Gift',
                component : FeedbackGift,
                meta : {
                    redirect : false
                }
            }
        ]
    },
    {
        path : '/feedback-finish',
        name : 'Feedback Finish',
        component : FeedbackFinish,
        meta : {
            redirect : false
        }
    },
    {
        path : '/dashboard',
        name : 'Dashboard',
        component : Dashboard,
        meta : {
            redirect : false
        }
    }
    
];